import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';

// eslint-disable-next-line import/no-unresolved
import EasyVirtualizedScroller from 'easy-react-virtualized';

import CommunityMessagesAPI from '../../../api/CommunityMessageAPI';
import Loader from '../../../components/Loader';
import showAppError from '../../../shared/error';
import { useAppSelector } from '../../../shared/hooks';
import { IMessageRoomParticipant } from '../../../types/communityMessagesTypes';
import CommunityUserCard from './CommunityUserCard';

type Props = {
  onlineUserList: IMessageRoomParticipant[];
  channelId: string;
  dmParticipentList?: IMessageRoomParticipant[];
  isDMRoom: boolean;
};

const NEW_USER_LIMIT = 10;

const initialState = {
  hasMore: true,
  loading: false,
  users: [],
  page: 1,
};

const CommunityChannelMemberList: React.FC<Props> = ({
  onlineUserList,
  channelId,
  dmParticipentList,
  isDMRoom,
}) => {
  const userDetails = useAppSelector((state) => state.user);
  const [offlineUserState, setOfflineUserState] = useState<{
    hasMore: boolean;
    loading: boolean;
    users: IMessageRoomParticipant[];
    page: number;
  }>(initialState);

  const onlineUserIds = useMemo(() => {
    return onlineUserList.map((each) => each?._id);
  }, [onlineUserList]);

  const getParticipentList = useCallback(async () => {
    // console.log(
    //   'this is called',
    //   offlineUserState?.loading,
    //   offlineUserState?.hasMore,
    // );
    if (isDMRoom) return;
    if (offlineUserState?.loading || !offlineUserState?.hasMore) return;
    try {
      // console.log('this is called 2');
      setOfflineUserState((prev) => ({ ...prev, loading: true }));
      const query = new URLSearchParams();
      query.append('limit', NEW_USER_LIMIT.toString());
      query.append('page', offlineUserState?.page.toString());
      const resp = await CommunityMessagesAPI.getParticipantsInChannel(
        channelId,
        query?.toString(),
      );
      if (resp?.status === 200) {
        const filteredUserList = resp?.data?.result?.filter(
          (eachUser) => !onlineUserIds.includes(eachUser?._id),
        );
        setOfflineUserState((prev) => {
          const currentUsers = [...prev.users];

          return {
            ...prev,
            users: [...currentUsers, ...filteredUserList].filter(
              (eachUser) => eachUser?._id !== userDetails?.id,
            ),
            loading: false,
            hasMore: resp?.data?.result?.length === NEW_USER_LIMIT,
            page: prev?.page + 1,
          };
        });
      } else {
        showAppError(resp?.data);
        setOfflineUserState((prev) => ({
          ...prev,
          loading: false,
          hasMore: false,
        }));
      }
    } catch (error) {
      setOfflineUserState((prev) => ({
        ...prev,
        loading: false,
        hasMore: false,
      }));
      showAppError(error);
    }
  }, [
    channelId,
    isDMRoom,
    offlineUserState?.hasMore,
    offlineUserState?.loading,
    offlineUserState?.page,
    onlineUserIds,
    userDetails?.id,
  ]);

  useEffect(() => {
    getParticipentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dmParticipentList) {
      const offlineUserList = dmParticipentList.reduce(
        (acc: IMessageRoomParticipant[], each) => {
          const isOnlineParticipent = onlineUserList.some(
            (eachUser) => eachUser?._id === each?._id,
          );
          if (!isOnlineParticipent) {
            return [...acc, each];
          }
          return acc;
        },
        [],
      );
      setOfflineUserState((prev) => ({
        ...prev,
        users: offlineUserList,
        hasMore: false,
      }));
    }
  }, [dmParticipentList, onlineUserList]);

  useEffect(() => {
    return () => {
      setOfflineUserState(initialState);
    };
  }, []);

  // console.log('onlineUserList', onlineUserList);
  console.log(
    'offlineUserState',
    offlineUserState?.users,
    offlineUserState?.hasMore,
  );
  // console.log('dmParticipentList', dmParticipentList);

  return (
    <div className="channel-info_container_scroll_user-container">
      <p>Members</p>
      <div>
        <div className="channel-info_container_scroll_user-container_users">
          {onlineUserList?.map((eachUser) => (
            <CommunityUserCard
              key={eachUser?._id}
              user={{ ...eachUser, profilePicType: 'image' }}
              isClickable={false}
              onClick={() => {}}
              isOnline
            />
          ))}
        </div>
        <div className="channel-info_container_scroll_user-container_users">
          {offlineUserState?.users && offlineUserState.users.length > 0 ? (
            <EasyVirtualizedScroller
              useParentScrollElement
              hasMore={offlineUserState?.hasMore}
              onLoadMore={() => getParticipentList()}>
              {/* Render offline users */}
              {offlineUserState?.users && offlineUserState.users.length > 0 ? (
                offlineUserState.users.map((eachUser) => (
                  <CommunityUserCard
                    key={eachUser?._id}
                    user={{ ...eachUser, profilePicType: 'image' }}
                    isClickable={false}
                    onClick={() => {}}
                  />
                ))
              ) : (
                <div>No offline users</div>
              )}

              {/* Show loader while fetching */}
              {offlineUserState.loading && (
                <Loader
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    marginTop: 16,
                  }}
                />
              )}
            </EasyVirtualizedScroller>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default memo(CommunityChannelMemberList);
